import { ReactNode } from 'react';

import { Skeleton } from '@mui/material';
import { Navigate, useParams } from 'react-router';

import { useProjectPermissions } from '../../hooks/useProjectPermissions';
import { ProjectAccessDenied } from '../ProjectAccessDenied/ProjectAccessDenied';
import { routes } from '@/constants/routes';

interface ProtectedProjectPageProps {
  children: ReactNode;
  requiredTab: 'planning' | 'financials' | 'team' | 'billing' | 'settings';
}

export const ProtectedProjectPage = ({
  children,
  requiredTab,
}: ProtectedProjectPageProps) => {
  const { projectId } = useParams<{ projectId: string }>();
  const { availableTabs, getDefaultTab, isLoading } = useProjectPermissions(
    projectId!,
  );

  if (isLoading) {
    return <Skeleton variant="rectangular" height="400px" />;
  }

  // If user has access to this tab, render it
  if (availableTabs[requiredTab]) {
    return <>{children}</>;
  }

  // Otherwise, redirect to first available tab
  const defaultTab = getDefaultTab();

  if (!defaultTab) {
    return <ProjectAccessDenied />;
  }

  return (
    <Navigate to={routes.projects.byTab(projectId!, defaultTab)} replace />
  );
};
